import axios from 'axios';

import moment from 'moment';

import get from 'lodash/get';

import { fetchItem } from '../core/storage';

import { updateSong } from '../stores/preload.bar.store';

import { clsAPIurl, getDesktopId, package_version, player_type } from '../config';

const desktop_id = await getDesktopId();

export async function getSongInfo() {
	try {
		const store_id = get(fetchItem('STORE_INFO'), 'storeId', '');
		const today = moment().format('YYYY-MM-DDTHH:mm');

		if (!store_id) {
			return;
		}

		const body = {
			host_id: store_id,
			request_type: 'venue',
			host_date: today,
		}

		const response = await axios({
			method: 'POST',
			url: `${clsAPIurl}/get_content`,
			data: body,
		});

		if (!response.data || !response.data.response) {
			console.warn('Error fetching song info:', response.data);
			return;
		} else if (response.data.response === true && response.data.song_info) {
			const songInfo = {
				songId: response.data.song_info.media_id,
				songTitle: response.data.song_info.media_title,
				artistName: response.data.song_info.media_artist,
				album: response.data.song_info.media_album,
				genre: response.data.song_info.media_genre,
				musicChannel: response.data.song_info.music_channel_id,
				shouldUpdateSpots: response.data.song_info.spots,
				time: response.data.song_info.media_playtime_string,
			};
			return songInfo;
		}

	} catch (err) {
		console.warn('Error :: getSongInfo', err);
	}
}

export async function startSong({ mediaId, isSpot, mediaType }) {
	try {
		const store_id = get(fetchItem('STORE_INFO'), 'storeId');

		const body = {
			store_id,
			media_id: mediaId,
			media_type: mediaType,
			isSpot,
		}

		const response = await axios({
			method: 'POST',
			url: `${clsAPIurl}/start_song`,
			data: body
		});

		return response.data;
	} catch (error) {
		console.warn('Error :: startSong', error);
	}
}

export async function endSong(mediaId, type) {
	try {
		const store_id = get(fetchItem('STORE_INFO'), 'storeId', '');
		const body = {
			store_id,
			media_id: mediaId ? mediaId : '0',
			media_type: type,
			player_type: player_type,
		}

		const response = await axios({
			method: 'POST',
			url: `${clsAPIurl}/end_song`,
			data: body
		});

		const responseRaw = response.data;

		if (responseRaw.response === true) {
			const responseBody = {
				response: responseRaw.response,
				songId: responseRaw.media_id || responseRaw.song_id,
				songTitle: responseRaw.media_title,
				artistName: responseRaw.media_artist,
				album: responseRaw.media_album,
				time: responseRaw.media_playtime_string,
				genre: responseRaw.media_genre,
				details: responseRaw.details,
				isJukebox: true,
				actionType: 'ending'
			}
			return responseBody;
		} else {
			return false
		}
	} catch (error) {
		console.warn('Error :: endSong', error);
	}
}

export async function alive({ isSpot, volume, status }) {
	try {
		const storeId = get(fetchItem('STORE_INFO'), 'storeId', '');

		const body = {
			store_id: storeId,
			media_type: isSpot ? 's' : 'm',
			status_player: status,
			request_type: 'venue',
			player_volume: volume,
			player_type: player_type,
			player_version: package_version
		}

		const response = await axios({
			method: 'POST',
			url: `${clsAPIurl}/alive`,
			data: body,
		})

		return response.data;
	} catch (error) {
		console.warn('Error :: alive', error);
		return false;
	}
}

export async function getSongById(songId, isSpot = false) {
	try {
		let url = `https://audio-file.yumix.us/${songId}`;

		if (isSpot) {
			url = `https://spot-file.yumix.us/${songId}`;
		}

		const response = await fetch(url);
		const reader = response.body.getReader();
		const contentLength = +response.headers.get('Content-Length');

		let receivedLength = 0;
		let progressEvent = {
			total: contentLength,
			loaded: 0,
		}
		let chunks = [];
		while (true) {
			const { done, value } = await reader.read();

			if (done) {
				break;
			}
			chunks.push(value);
			receivedLength += value.length;
			progressEvent.loaded = receivedLength
			updateSong(progressEvent, songId);
		}

		const blob = new Blob(chunks);
		return URL.createObjectURL(blob);
	} catch (err) {
		console.warn('Error :: getSongById', err);
	}
}

export function getSongCoverById(songId, isSpot = false) {
	let url = `https://audio-art.yumix.us/${songId}`;
	if (isSpot) {
		url = `https://spot-art.yumix.us/${songId}`;
	}
	return url;
}

export async function getSpotsSegments() {
	const storeId = get(fetchItem('STORE_INFO'), 'storeId', '');

	if (!storeId) {
		console.log('No storeId provided');
		return;
	}

	const body = {
		store_id: storeId,
		request_type: 'venue',
	}

	const response = await axios({
		method: 'POST',
		url: `${clsAPIurl}/spot_segments`,
		data: body,
	});

	if (!response.data || !response.data.response) {
		console.warn('Error fetching spot segments:', response.data);
		return;
	} else if (response.data.response === true && response.data.spots) {
		const segments = response.data.spots;

		const spotsSegments = segments.reduce((acc, curr) => {
			if (!acc[curr.t]) {
				acc[curr.t] = [curr.id];
				return acc;
			}
			acc[curr.t].push(curr.id);
			return acc;
		}, {});

		return spotsSegments;
	}
}

export async function checkImageUrl(url) {
	try {
		const response = await fetch(url, { method: 'HEAD' });
		if (response.ok) {
			return url;
		} else {
			console.warn(`Image not found at ${url}`);
			return false;
		}
	} catch (error) {
		console.warn(`Error checking image URL ${url}:`, error);
		return false;
	}
}
